import { firebaseAuth } from "@/firebase/firebaseAuth";
import firestore from "../../../firebase/firestore";
import { getInstallments } from "../../../services/installments";

export default {
  resetFilter({ commit }) {
    commit("resetState");
  },
  async getUserByID({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      commit("setCurrentUser", {});
      commit("setLoading", true);
      let usersRef = firestore.collection("users");
      usersRef
        .doc(id)
        .get()
        .then((user) => {
          let new_doc = {
            id: user.id,
            ...user.data(),
          };
          dispatch("getConsumerUnitsByUser", id);
          commit("setCurrentUser", new_doc);
          commit("setLoading", false);
          resolve(new_doc);
        })
        .catch((err) => {
          console.error(err.message);
          commit("setLoading", false);
          reject(err);
        });
    });
  },
  getConsumerUnitsByUser({ commit, dispatch }, user_id) {
    return new Promise((resolve, reject) => {
      commit("setConsumerUnits", []);
      commit("setLoading", true);
      let ucsRef = firestore.collection("consumer_units");
      // let _ucs = []
      return ucsRef
        .where("user_id", "==", user_id)
        .get()
        .then((ucs) => {
          if (ucs.size > 0) {
            let _ucs = ucs.docs.map((uc) => {
              return { id: uc.id, ...uc.data() };
            });
            commit("setConsumerUnit", {
              id: ucs.docs[0].id,
              ...ucs.docs[0].data(),
            });
            commit("setConsumerUnits", _ucs);
            dispatch("getBillingsByUserAndConsumerUnit", {
              customer_id: user_id,
              consumer_unit: ucs.docs[0].id,
            });
          }
        })
        .catch((err) => reject(err));
    });
  },
  async getBillingsByUser({ commit }, params) {
    // let billingsTotal = 0
    return new Promise((resolve, reject) => {
      try {
        commit("setLoading", true);
        commit("setBillings", []);
        commit("setBilling", {});
        if (params) {
          let billingRef = firestore.collection("billing");
          if (params.customer_id) {
            billingRef = billingRef.where(
              "customer_id",
              "==",
              params.customer_id,
            );
          }
          // } else {
          //     alert('Erro: Vendendor não identificado!')
          //     return
          // }
          billingRef = billingRef
            // .orderBy('consumer_unit', 'asc')
            .orderBy("competence", "desc");
          // .limit(12)

          billingRef.onSnapshot(async (res) => {
            let billings = [];
            const changes = res.docChanges();
            // eslint-disable-next-line no-unused-  rs
            for (const [, change] of changes.entries()) {
              const { doc } = change;
              switch (change.type) {
                case "added": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  billings.push(data);
                  break;
                }
                case "modified": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  // eslint-disable-next-line no-shadow
                  const i = billings.findIndex((i) => i.id === doc.id);
                  billings[i] = data;
                  break;
                }
                case "removed": {
                  billings = billings.filter((i) => i.id !== doc.id);
                  break;
                }
                default:
                  break;
              }
            }
            commit(
              "setBillings",
              billings.filter((b) =>
                [
                  "paid",
                  "free",
                  "overdue",
                  "parceled",
                  "waiting_payment",
                  "postponed",
                  "refused",
                  "negotiated",
                  "refunded",
                  "in_queue",
                  "reprocessing",
                  "chargedback",
                ].includes(b.status),
              ),
            );
            commit("setLoading", false);
            resolve(billings);
          });
        }
      } catch (err) {
        commit("setBillings", []);
        commit("setLoading", false);
        reject(err);
        console.error(err);
      }
    });
  },
  async getBillingsByUserAndConsumerUnit({ commit }, params) {
    // let billingsTotal = 0
    return new Promise((resolve, reject) => {
      try {
        commit("setLoading", true);
        commit("setBillings", []);
        commit("setBilling", {});
        if (params) {
          let billingRef = firestore.collection("billing");
          if (params.customer_id) {
            billingRef = billingRef.where(
              "customer_id",
              "==",
              params.customer_id,
            );
          }
          if (params.consumer_unit) {
            billingRef = billingRef.where(
              "consumer_unit",
              "==",
              params.consumer_unit,
            );
          }
          // } else {
          //     alert('Erro: Vendendor não identificado!')
          //     return
          // }
          billingRef = billingRef
            // .orderBy('consumer_unit', 'asc')
            .orderBy("competence", "desc");
          // .limit(12)

          billingRef.onSnapshot(async (res) => {
            let billings = [];
            const changes = res.docChanges();
            // eslint-disable-next-line no-unused-  rs
            for (const [, change] of changes.entries()) {
              const { doc } = change;
              switch (change.type) {
                case "added": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  billings.push(data);
                  break;
                }
                case "modified": {
                  const data = {
                    id: doc.id,
                    ...doc.data(),
                  };
                  // eslint-disable-next-line no-shadow
                  const i = billings.findIndex((i) => i.id === doc.id);
                  billings[i] = data;
                  // console.log('modified after splice2', billings)
                  break;
                }
                case "removed": {
                  billings = billings.filter((i) => i.id !== doc.id);
                  break;
                }
                default:
                  break;
              }
            }
            commit(
              "setBillings",
              billings.filter((b) =>
                [
                  "paid",
                  "free",
                  "overdue",
                  "parceled",
                  "waiting_payment",
                  "postponed",
                  "refused",
                  "negotiated",
                  "refunded",
                  "in_queue",
                  "reprocessing",
                  "chargedback",
                ].includes(b.status),
              ),
            );
            commit("setLoading", false);
            resolve(billings);
          });
        }
      } catch (err) {
        commit("setBillings", []);
        commit("setLoading", false);
        reject(err);
        console.error(err);
      }
    });
  },
  getInstallmentsByUC({ commit }, data) {
    return new Promise((resolve, reject) => {
      getInstallments(data)
        .then((installments) => {
          if (installments.status === 200) {
            commit("setInstallments", installments.data);
            resolve(installments.data);
          } else {
            console.error(installments);
            reject(installments);
          }
        })
        .catch((err) => {
          console.error(err);
          reject(err);
        });
    });
  },
  anonymousLogin({ commit }) {
    return new Promise((resolve, reject) => {
      return firebaseAuth
        .signInAnonymously()
        .then(async (res) => {
          return await res.user
            .getIdToken()
            .then((token) => {
              commit(
                "authUser",
                {
                  idToken: token,
                  userId: res.user.uid,
                },
                { root: true },
              );
              const now = new Date();
              //Configura o logout para daqui 2 horas
              const expirationDate = new Date(now.getTime() + 7200000);
              localStorage.setItem("token", token);
              localStorage.setItem("expirationDate", expirationDate);
              resolve(res);
            })
            .catch((error) => {
              var errorCode = error.code;
              var errorMessage = error.message;
              console.error(errorCode + " - " + errorMessage);
              reject(error);
            });
        })
        .catch((error) => {
          var errorCode = error.code;
          var errorMessage = error.message;
          console.error(errorCode + " - " + errorMessage);
          reject(error);
        });
    });
  },
};
